import { useCallback, useEffect } from 'react'
import ReactDOM from 'react-dom'
import './Modal.scss'

export const Modal = ({
  isOpen,
  onClose,
  title,
  children,
  size = 'md',
  footer,
  closable = true,
}) => {
  const handleEscape = useCallback(
    e => {
      if (e.key === 'Escape' && closable) onClose()
    },
    [onClose, closable]
  )

  useEffect(() => {
    if (isOpen) {
      document.addEventListener('keydown', handleEscape)
      document.body.style.overflow = 'hidden'
    }
    return () => {
      document.removeEventListener('keydown', handleEscape)
      document.body.style.overflow = ''
    }
  }, [isOpen, handleEscape])

  if (!isOpen) return null

  return ReactDOM.createPortal(
    <div className="tb-modal-overlay" onClick={closable ? onClose : undefined}>
      <div
        className={`tb-modal tb-modal--${size}`}
        onClick={e => e.stopPropagation()}
      >
        <div className="tb-modal__header">
          <h3 className="tb-modal__title">{title}</h3>
          {closable && (
            <button className="tb-modal__close" onClick={onClose}>
              <svg
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2.5"
                strokeLinecap="round"
              >
                <line x1="18" y1="6" x2="6" y2="18" />
                <line x1="6" y1="6" x2="18" y2="18" />
              </svg>
            </button>
          )}
        </div>
        <div className="tb-modal__body">{children}</div>
        {footer && <div className="tb-modal__footer">{footer}</div>}
      </div>
    </div>,
    document.body
  )
}
